<app-navbar></app-navbar>
<router-outlet></router-outlet>
<app-footer></app-footer>
@if (screenSizeService.isBrowser) {
  <app-cookie-tool></app-cookie-tool>
}
